import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const EstimateBox = styled.div`
  padding: var(--space-8) var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    margin-inline: var(--space-10);
  `)}
`;

const Buttons = styled.div`
  display: flex;
  gap: var(--space-6);
  pointer-events: auto;
`;

export { EstimateBox, Buttons };
